import React from "react";
import { UserIcon, MailIcon, MessageSquareIcon } from "lucide-react";

const ContactForm = () => {
  return (
    <div className="absolute z-30 top-1/2 right-24 transform -translate-y-1/2 w-[340px]">
      <form className="bg-white/10 backdrop-blur-md p-8 rounded-xl border border-white/20 shadow-lg text-white font-roboto space-y-6">
        {/* Name Field */}
        <div className="relative">
          <UserIcon className="absolute top-2.5 left-2.5 w-5 h-5 text-white/60" />
          <input
            type="text"
            name="name"
            placeholder="Your name"
            className="w-full pl-10 pr-4 py-2 bg-transparent border-b border-white/40 placeholder-white/60 text-sm focus:outline-none"
            required
          />
        </div>

        {/* Email Field */}
        <div className="relative">
          <MailIcon className="absolute top-2.5 left-2.5 w-5 h-5 text-white/60" />
          <input
            type="email"
            name="email"
            placeholder="Your email"
            className="w-full pl-10 pr-4 py-2 bg-transparent border-b border-white/40 placeholder-white/60 text-sm focus:outline-none"
            required
          />
        </div>

        {/* Message Field */}
        <div className="relative">
          <MessageSquareIcon className="absolute top-2.5 left-2.5 w-5 h-5 text-white/60" />
          <textarea
            name="message"
            placeholder="Message..."
            rows="4"
            className="w-full pl-10 pr-4 py-2 bg-transparent border-b border-white/40 placeholder-white/60 text-sm focus:outline-none resize-none"
            required
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-white text-black text-sm font-medium tracking-wide uppercase py-2 rounded hover:bg-white/90 transition"
        >
          Book an Appointment
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
